if ("production" !== process.env.NODE_ENV) {
    console.warn("[mobx-react-lite] importing batchingForReactDom is no longer needed")
}
